import { SellTag } from "@/models/maxEnums";

export default new class SellTagService {
    public contains(sellTags: number, sellTag: SellTag): boolean {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison,no-bitwise
        return (sellTags & sellTag) === sellTag;
    }
}();
